export default __webpack_public_path__ + "static/media/discord.4e55cae5.svg";